import { createFileRoute } from '@tanstack/react-router'
import { LoginForm } from '../components/LoginForm'
import { AuthLayout } from '../components/auth/AuthLayout'
import { validateLoginSearch } from '../lib/login-search'

// The org-less login page (spec 2026-10-14-22): the account is authenticated
// first, then the server picks the organization. The first segment of `next`
// is the hint (`/login?next=/agi3/...` hints `agi3`).
export const Route = createFileRoute('/login')({
  component: Login,
  validateSearch: validateLoginSearch,
})

function Login() {
  return (
    <AuthLayout>
      <LoginForm />
    </AuthLayout>
  )
}
